"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var withTest = function (defaultTest) { return function (enumVal, testFn) {
    return Object.keys(enumVal)
        .filter(testFn || defaultTest)
        .map(function (key) { return enumVal[key]; });
}; };
exports.default = withTest(function (val) { return true; });
